import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { FlowersFamilies } from './flowersDesktop';
import {
    Box,
    Typography,
    Dialog,
    DialogContent,
    IconButton,
    Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BackIcon from '../../../../../components/back/back';

export default function FlowersDetails() {
    const { name } = useParams<{ name?: string }>();
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    if (!name) return <p>Invalid plant name.</p>;

    const decodedName = decodeURIComponent(name);
    const plant = FlowersFamilies.find(
        (item) => item.name.toLowerCase() === decodedName.toLowerCase()
    );

    if (!plant) return <p>Plant not found.</p>;

    const handleImageClick = (src: string) => {
        setSelectedImage(src);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };

    return (
        <div className="ficus-container">
            <BackIcon />
            <Box sx={{ textAlign: 'center', px: '1rem' }}>
                <div className="title-with-flowers title-overlay">
                    <span className="flower">🍁</span>
                    <h1>{plant.name}</h1>
                    <span className="flower">🍁</span>
                </div>

                <Typography
                    sx={{
                        mt: 2,
                        fontSize: { xs: '1rem', md: '1.2rem' },
                        fontFamily: 'Century Gothic',
                    }}
                >
                    {plant.description}
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                {plant.gallery && plant.gallery.length > 0 ? (
                    <Grid
                        container
                        spacing={3}
                        sx={{ mt: 8, px: 2 }}
                        justifyContent="center"
                    >
                        {plant.gallery.map((imgObj, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                key={index}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    paddingBottom: '2rem',
                                }}
                            >
                                <Box
                                    onClick={() => handleImageClick(imgObj.src)}
                                    className="ficus-shape-card"
                                    sx={{
                                        p: 2,
                                        bgcolor: 'white',
                                        borderRadius: 2,
                                        boxShadow: 3,
                                        transition: 'transform 0.3s',
                                        cursor: 'pointer',
                                        '&:hover': { transform: 'scale(1.05)' },
                                    }}
                                >
                                    <img
                                        src={imgObj.src}
                                        alt={`${plant.name}-${index}`}
                                        style={{
                                            width: '100%',
                                            height: '15rem',
                                            objectFit: 'cover',
                                            borderRadius: '8px',
                                            marginBottom: '0.5rem',
                                        }}
                                    />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography
                        sx={{
                            mt: 8,
                            fontSize: { xs: '1rem', md: '1.2rem' },
                            fontStyle: 'italic',
                            color: 'gray',
                        }}
                    >
                        Images coming soon...
                    </Typography>
                )}
            </Box>

            <Dialog open={open} onClose={handleClose} maxWidth="lg">
                <DialogContent sx={{ position: 'relative', p: 0 }}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 10,
                            color: 'white',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {selectedImage && (
                        <img
                            src={selectedImage}
                            alt="Full Size"
                            style={{
                                width: '100%',
                                height: 'auto',
                                display: 'block',
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}
